import { fetchDataAPI } from '../helpers/fetchDataAPI';
import { URL_BASE_API } from './glogal';
import { store } from '../store'
import { Field } from 'formik';


export const sendVerificationCode = (email) => {
    const url = `${URL_BASE_API}/api/registration/sendverificationcode`;
    const language = store.getState().configuration.language;
    const rsp = fetchDataAPI(url, {
        field01: email,
        lang: language
    });
    
    return rsp;
}

export const isValidCode = (email, code) => {
    const url = `${URL_BASE_API}/api/registration/isvalidcode`;
    const language = store.getState().configuration.language;
    const rsp = fetchDataAPI(url, {
        field01: email,
        field02: code,
        lang: language
    });
    
    return rsp;
}

export const register = (data) => {
    const url = `${URL_BASE_API}/api/registration/register`;
    const language = store.getState().configuration.language;
    const rsp = fetchDataAPI(url, {
        field01: data.name,
        field02: data.company,
        field03: data.originCountry,
        field04: data.email,
        field05: data.phone,
        field06: data.urlTiktok,
        field07: data.urlSpotify,
        field08: data.urlAppleMusic,
        field09: data.password,
        lang: language
    });
    
    return rsp;
}
